import { useEffect, useState } from "react";

const OfficeSystemInformationView = ({ data }) => {
  const [details, setDetails] = useState({});
  useEffect(() => {
    setDetails({
      CreadtedBy: ["Created By", data.createdBy],
      LastModifiedBy: ["Last Modified By", data.updatedBy],
      CreatedOn: [
        "Created Date",
        data.createdOn
          ? new Date(data.createdOn).toLocaleDateString() +
            " " +
            new Date(data.createdOn).toLocaleTimeString(navigator.language, {
              hour: "2-digit",
              minute: "2-digit",
            })
          : " ",
      ],
      LastModifiedDate: [
        "Last Modified Date",
        data.updatedOn
          ? new Date(data.updatedOn).toLocaleDateString() +
            " " +
            new Date(data.updatedOn).toLocaleTimeString(navigator.language, {
              hour: "2-digit",
              minute: "2-digit",
            })
          : " ",
      ],
    });
  }, []);
  return (
    <div className="w-full">
      <div className="grid text-xs px-9 py-2 gap-y-1 md:grid-cols-2">
        {Object.values(details).map((item, i) => {
          return (
            <div key={i} className="w-full border-b border-gray-200 py-1">
              <div className="grid grid-cols-2">
                <div className="expandedLabel fontExpand text-left">
                  <span>{item[0]}:</span>
                </div>
                <span className="expandedData fontExpand">
                  {item[1] === null || item[1] === "NULL" ? "" : item[1]}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default OfficeSystemInformationView;
